document.addEventListener('DOMContentLoaded', function () {
  const subBlock = document.getElementById('substitution-block');
  if (!subBlock) return;

  const variantStockMap = {};
  subBlock.dataset.variantStock.split(',').forEach(entry => {
    const [id, qty] = entry.split(':');
    variantStockMap[parseInt(id)] = parseInt(qty);
  });

  function checkVariant() {
    const selectedId = document.querySelector('input[name="id"], select[name="id"]')?.value;
    if (!selectedId) return;
    const qty = variantStockMap[parseInt(selectedId)];
    subBlock.style.display = (qty !== undefined && qty <= 0) ? 'block' : 'none';
  }

  // Delay to let the theme initialize the selected variant
  setTimeout(checkVariant, 300);

  document.querySelector('form[action="/cart/add"]')
    ?.addEventListener('change', checkVariant);

  document.addEventListener('variant:change', function (e) {
    const id = e.detail?.variant?.id;
    if (id) {
      const qty = variantStockMap[id];
      subBlock.style.display = (qty !== undefined && qty <= 0) ? 'block' : 'none';
    }
  });
});